import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../state';
import { ConnectionSelectionContainer } from './ConnectionSelectionContainer';
import { PwWebConection } from '../../../types';

export const mapState = (state: RematchRootState<RootModel>) => ({
  project: state.projects.project,
  connections: state.connections.connections,
  connection: state.connections.connection,
  services: state.services.services,
  tabIsDefault: state.connections.tabIsDefault,
});

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  loadConnections: async () => dispatch.connections.loadConnections({}),
  loadServices: async () => dispatch.services.loadServices({}),
  setConnection: (connection: PwWebConection) =>
    dispatch.connections.setConnection(connection),
  setTabName: (tabName: string) => dispatch.tab.setTabName(tabName),
  loadTabIsDefault: async () => dispatch.connections.loadTabIsDefault({}),
  setTabIsDefault: (newValue: boolean) =>
    dispatch.connections.setTabIsDefault(newValue),
});

export const ConnectedConnectionSelection = connect(
  mapState,
  mapDispatch
)(ConnectionSelectionContainer);
